import React, { ReactElement } from 'react';
import { isDarkMode } from 'utils/helpers';

interface ChangeEmailIconProps {
  fillColor?: string;
}

const ChangeEmailIcon = ({ fillColor = '#D9D9D9' }: ChangeEmailIconProps): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
      <mask
        id="mask0_3941_18828"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="27"
        height="26"
      >
        <rect x="0.5" width="26" height="26" fill={fillColor} />
      </mask>
      <g mask="url(#mask0_3941_18828)">
        <path
          d="M17.779 23.4508C17.6173 23.4508 17.4635 23.4239 17.3177 23.3701C17.1718 23.3164 17.0383 23.2288 16.917 23.1076L13.9202 20.1172C13.6957 19.8927 13.5834 19.6097 13.5834 19.2682C13.5834 18.9267 13.6957 18.6437 13.9202 18.4192C14.1447 18.1947 14.4277 18.0824 14.7692 18.0824C15.1107 18.0824 15.3937 18.1947 15.6182 18.4192L17.779 20.5799L22.9731 15.3859C23.1976 15.1613 23.4806 15.0491 23.8221 15.0491C24.1636 15.0491 24.4466 15.1613 24.6711 15.3859C24.8956 15.6104 25.0079 15.8934 25.0079 16.2349C25.0079 16.5763 24.8956 16.8593 24.6711 17.0839L18.6409 23.1076C18.5197 23.2288 18.3861 23.3164 18.2403 23.3701C18.0945 23.4239 17.9407 23.4508 17.779 23.4508ZM4.91087 6.57789L13.4998 11.8197L22.0887 6.57789H4.91087ZM4.91087 21.887C4.22868 21.887 3.64736 21.6468 3.16692 21.1664C2.6865 20.6859 2.44629 20.1046 2.44629 19.4224V6.57789C2.44629 5.8957 2.68652 5.31438 3.16698 4.83394C3.6474 4.3535 4.22871 4.11328 4.9109 4.11328H22.0888C22.771 4.11328 23.3523 4.3535 23.8327 4.83394C24.3132 5.31438 24.5534 5.8957 24.5534 6.57789V10.7723L22.0888 13.2368V8.94533L14.1268 13.8091C14.0279 13.8719 13.9245 13.9169 13.8166 13.944C13.7086 13.971 13.603 13.9846 13.4998 13.9846C13.3966 13.9846 13.291 13.971 13.183 13.944C13.0751 13.9169 12.9717 13.8719 12.8728 13.8091L4.91087 8.94533V19.4224H10.1921L12.6567 21.887H4.91087Z"
          fill={isDarkMode() ? '#71B5E4' : '#0D5C93'}
        />
      </g>
    </svg>
  );
};

export default ChangeEmailIcon;
